"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  init: true
};
exports.init = init;

var _base = require("./base");

var _interface = require("./interface");

Object.keys(_interface).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _interface[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _interface[key];
    }
  });
});

// import { PhoneNumberUtil } from "google-libphonenumber";
// const phoneUtil = PhoneNumberUtil.getInstance();
var _inited;

function init(config) {
  if (_inited) return new Promise(function (resolve) {
    return resolve();
  });

  if (config) {
    return (0, _base.initBase)(config.countryTimezone).then(function () {
      _inited = true;
    });
  } else {
    return fetch("https://static.didiglobal.com/ibt/elvish/countryTimezone.json").then(function (res) {
      return res.json();
    }).then(_base.initBase).then(function () {
      _inited = true;
    });
  }
} // 根据国家码查询国家电话码
// export function getTelPrefix(countryCode) {
//   const res = phoneUtil.getExampleNumber(countryCode).getCountryCode();
//   return res ? '+' + res : '';
// }